// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__13znf","errorLogs":"EditorFooter_errorLogs__2JA8a"};